export const affordDataModule = {
    namespaced: true,
    state: {
      province_id: null,
      income: null,
      savings: null
    },
    mutations: {
      SET_PROVINCE_ID: (state, provinceId) => {
        state.province_id = provinceId
      },
      SET_INCOME: (state, income) => {
        state.income = income
      },
      SET_SAVINGS: (state, savings) => {
        state.savings = savings
      },
      CLEAR_ALL: (state) => {
        state.province_id = null
        state.income = null
        state.savings = null
      }
    },
    getters: {
      all: state => {
        return state
      },
      provinceId: state => {
        return state.province_id
      },
      income: state => {
        return state.income
      },
      savings: state => {
        return state.savings
      }
    },
    actions: {
      clearAll (ctx) {
        ctx.commit('CLEAR_ALL')
      }
    }
  }
  